import AdvanceTable from '../../components/base/AdvanceTable';
import { Link } from 'react-router-dom';
import AdvanceTableFooter from '../../components/base/AdvanceTableFooter';
import Avatar from '../../components/base/Avatar';
import { ProgressBar } from 'react-bootstrap';
import RevealDropdown, {
  RevealDropdownTrigger
} from '../../components/base/RevealDropdown';
import ActionDropdownItems from '../../components/common/ActionDropdownItems';
import axios from 'axios';
import { API } from '../../config/api';
const colorHex = {
  WHITE: '#ffffff',
  BLACK: '#000000',
  GREY: '#808080',
  'GREY 7004': '#9AA0A6', // adjust if you want a different RAL
  BLUE: '#1e88e5',
  BROWN: '#795548',
  'GREEN-YELLOW': '#9acd32'
};
const ColorCell = ({ value }) => {
  if (!value) return <span className="text-700">—</span>;
  const hex = colorHex[value.toUpperCase()];
  return (
    <span className="d-inline-flex align-items-center gap-2">
      <span
        style={{
          width: 14,
          height: 14,
          borderRadius: '50%',
          border: '1px solid #ccc',
          background:
            hex ||
            'linear-gradient(45deg,#bbb 25%,#eee 25%,#eee 50%,#bbb 50%,#bbb 75%,#eee 75%)',
          backgroundSize: hex ? undefined : '8px 8px'
        }}
        title={value}
      />
      <span className="white-space-nowrap">{value}</span>
    </span>
  );
};

export const StandardListTableColumns = (
  setOpenDetailsModal,
  setStandard,
  deteleStandard
) => [
  {
    accessorKey: 'name',
    header: 'Name',
    cell: ({ row: { original } }) => {
      const { _id, name } = original;
      return (
        <Link
          to={`/apps/standard/${_id}`}
          className="text-decoration-none fw-bold fs-8"
        >
          {name.toUpperCase()}
        </Link>
      );
    },
    meta: {
      cellProps: { className: 'white-space-nowrap py-4' },
      headerProps: { style: { width: '5%' } }
    }
  },
  {
    accessorKey: 'numberOfConductors',
    header: 'conductors',

    meta: {
      cellProps: { className: 'ps-3 py-4' },
      headerProps: { style: { width: '5%' }, className: 'ps-3' }
    }
  },
  {
    header: 'Section',
    accessorKey: 'section',
    cell: ({ row: { original } }) => {
      const { section, hasMixedConductorSections, greenYellowSection } =
        original;

      if (
        hasMixedConductorSections &&
        greenYellowSection != null &&
        greenYellowSection !== ''
      ) {
        return (
          <span className="white-space-nowrap">
            {section} <span className="text-700"> + </span>{' '}
            <span className="white-space-nowrap">{greenYellowSection} mm²</span>
          </span>
        );
      }

      // fallback (normal)
      return <span className="white-space-nowrap">{section} mm²</span>;
    },
    meta: {
      cellProps: { className: 'ps-3 fs-9 text-900 white-space-nowrap py-4' },
      headerProps: { style: { width: '8%' }, className: 'ps-3' }
    }
  },
  {
    header: 'Color',
    accessorKey: 'color',
    cell: ({ row: { original } }) => <ColorCell value={original.color} />,
    meta: {
      cellProps: { className: 'ps-3 fs-9 text-900 white-space-nowrap py-4' },
      headerProps: { style: { width: '8%' }, className: 'ps-3' }
    }
  },
  {
    header: 'Product Standard',
    accessorKey: 'productStandard',
    meta: {
      cellProps: { className: 'ps-3 fs-9 text-900 white-space-nowrap py-4' },
      headerProps: { style: { width: '10%' }, className: 'ps-3' }
    }
  },
  {
    accessorKey: 'performanceStandard',
    header: 'Performance standard',
    meta: {
      cellProps: { className: 'ps-3 text-900 py-4' },
      headerProps: { style: { width: '12%' }, className: 'ps-3' }
    }
  },
  {
    accessorKey: 'notifiedBody',
    header: 'Notified Body',

    meta: {
      cellProps: { className: 'ps-3 py-4' },
      headerProps: { style: { width: '10%' }, className: 'ps-3' }
    }
  },
  {
    accessorKey: 'dop',
    header: 'DOP',

    meta: {
      cellProps: { className: 'ps-3 py-4' },
      headerProps: { style: { width: '5%' }, className: 'ps-3' }
    }
  },
  {
    id: 'tension',
    accessorKey: 'tension',
    header: 'Tension',
    meta: {
      cellProps: { className: 'ps-8 py-4' },
      headerProps: { style: { width: '10%' }, className: 'ps-8' }
    }
  },
  {
    accessorKey: 'fireReaction',
    header: 'Reaction to Fire',

    meta: {
      cellProps: { className: 'ps-3 py-4' },
      headerProps: { style: { width: '5%' }, className: 'ps-3' }
    }
  },
  {
    id: 'action',
    cell: ({ row: { original } }) => (
      <RevealDropdownTrigger>
        <RevealDropdown>
          <ActionDropdownItems
            firstItem={'Edit'}
            secondItem={'Remove'}
            firstItemFunc={() => {
              setStandard(original);
              setOpenDetailsModal(true);
            }}
            secondItemFunc={async () => {
              const confirmDelete = window.confirm(
                'Are you sure you want to delete this standard?'
              );

              if (!confirmDelete) return;

              try {
                const response = await axios.delete(
                  `${API.BACKEND}/api/v1/standard/${original._id}`
                );

                alert('Standard deleted successfully!');

                deteleStandard(original._id); // Update state
              } catch (error) {
                console.error('Error deleting standard:', error);

                alert(
                  `Failed to delete standard: ${
                    error.response?.data?.message || error.message
                  }`
                );
              }
            }}
          />
        </RevealDropdown>
      </RevealDropdownTrigger>
    ),
    meta: {
      headerProps: { style: { width: '10%' }, className: 'text-end' },
      cellProps: { className: 'text-end' }
    }
  }
];

const StandardListTable = () => {
  return (
    <div className="border-bottom">
      <AdvanceTable
        tableProps={{
          className: 'phoenix-table border-top border-200 fs-9'
        }}
      />
      <AdvanceTableFooter pagination className="py-3" />
    </div>
  );
};

export default StandardListTable;
